module.exports = __webpack_public_path__ + "img/128.33e209d0.svg";